export default __webpack_public_path__ + "static/media/avatar.81f94623.png";